module.exports = __webpack_public_path__ + "img/Spencers_Logo.36efb565.png";